/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-profil-question-look-3': {
    width: 19,
    height: 54,
    viewBox: '0 0 19 54',
    data: '<path pid="0" class="st0" d="M9.4 49.4l-4.2-3.3L7 19.8l2.3-2.6 2.3 2.6 1.8 26.3-4 3.3zm-2-39.3h4.1l-2 2.2-2.1-2.2zm4.2 4.6l7.2-8h-.1V0h-3.3v6.8H3.3V0H0V6.9l7.2 7.9-3.3 3.7-2 29.2 7.6 6 7.6-6-2-29.2-3.5-3.8z"/>'
  }
})
